import { Box } from '@mui/material';
import { ReactNode } from 'react';

type Props = {
    children: ReactNode;
};

const VisibleOnMobile = ({ children }: Props) => {
    return <Box sx={{ display: { xs: 'block', md: 'none' } }}>{children}</Box>;
};

export default VisibleOnMobile;
